export const routes = [{
  path: '/pacote',
  component: () =>
    import(/* webpackChunkName: "tema" */ './components/List'),
  name: 'pacote.list',
  meta: {
    requiresAuth: true
  }
}]
